import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase, FUNCTIONS_URL } from '../lib/supabase';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Mevcut oturumu yükle
    supabase.auth.getSession()
      .then(({ data: { session } }) => {
        setUser(session?.user ?? null);
        setLoading(false);
      })
      .catch(() => {
        // Supabase erişilemezse (paused, DNS hatası vb.) loading'de takılmasın
        setLoading(false);
      });

    // Oturum değişikliklerini dinle
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const register = async (name, email, password) => {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: { data: { name } },
    });
    if (error) throw new Error(error.message);
    if (!data.user) throw new Error('Kayıt başarısız');

    // Email onayı kapalıysa session hemen gelir
    if (data.session) {
      setUser(data.user);
    } else {
      // Email onayı açıksa direkt login dene
      const { error: loginError } = await supabase.auth.signInWithPassword({ email, password });
      if (loginError) throw new Error('Kayıt başarılı, giriş yapılıyor...');
    }
  };

  const login = async (email, password) => {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw new Error(error.message);
  };

  const logout = () => supabase.auth.signOut();

  // Test amaçlı — Supabase'de gerçek kullanıcı gerektirir
  const adminLogin = async () => {
    await login('admin@vidflow.com', 'admin123');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, adminLogin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

// Edge function URL — diğer componentlerde import edilir
export { FUNCTIONS_URL as API_URL };
